<script lang="ts" setup>

  import { BngGolfResultCard, BngHomeCard, BngMobileGolfCard } from '~/components/golf'
  import type { Hole, Nullable } from '~/core/types'
  import type { Position } from '~/core/types/shared'

  type Props = {
    golf: {
      id: number // *
      name: string // *
      slug?: string
      best_price?: number
      commune?: string
      region?: string
      country?: string
      position: Position // *
      holes?: Hole[]
      has_promotions?: boolean
      thumb?: string
      distance?: number
      departure_count?: Nullable<number>
      services?: string[]
      rating?: Nullable<number>
      rating_count?: number
    }
    isHome?: boolean
    rating?: boolean
    departures?: boolean
    displayMobile?: boolean
  }
  const props = defineProps<Props>()

  const { user } = storeToRefs(useUserStore())
  const { favorites, toggleFavorite } = useFavorite()
  const route = useRoute()
  const router = useRouter()

  const windowWidth = ref(0)
  const isFavorite = computed(() => favorites.value?.data?.map((golf) => golf.id).includes(props.golf.id))

  const { matches: matchDesktop } = useMatchMedia(ScreenWidth.desktop)

  function toggleFavoriteGolf() {
    if (user.value) {
      toggleFavorite(props.golf)
    } else {
      router.push({ query: { ...route.query, modal: 'login' } })
    }
  }

  onMounted(() => {
    window.onresize = () => {
      windowWidth.value = window.innerWidth
    }
  })

</script>
<template>
  <div class="c-golf-card-wrapper">
    <BngMobileGolfCard
      v-if="displayMobile && !matchDesktop"
      :golf="golf"
      rating
      :is-favorite="isFavorite"
      :departures="departures"
      @toggle-favorite="toggleFavoriteGolf"
    />
    <BngHomeCard
      v-else-if="isHome"
      :golf="golf"
      :is-favorite="isFavorite"
      :rating="rating"
      :departures="departures"
      @toggle-favorite="toggleFavoriteGolf"
    />
    <BngGolfResultCard
      v-else
      :golf="golf"
      :is-favorite="isFavorite"
      :departures="departures"
      @toggle-favorite="toggleFavoriteGolf"
    />
  </div>
</template>
<style scoped>

.c-golf-card-wrapper {
  display: flex;
  overflow: hidden;
  flex: 0 1 100%;
}
</style>
